<template>
    <router-view></router-view>
</template>
<script>
export default {
    name: 'documents'
}
</script>
